import { Button, ButtonProps } from '@progress/kendo-react-buttons';

const CircularIconButton = (props: ButtonProps) => (
  <Button
    style={{
      border: '1px solid white',
      borderRadius: '50%',
      padding: '0px',
    }}
    {...props}
  />
);

export default CircularIconButton;
